var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomePage01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1036 690",
    style: {
      enableBackground: "new 0 0 1036 690"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9F9F9;}\n\t.st1{opacity:0.46;}\n\t.st2{fill:#BFD9FF;}\n\t.st3{fill:none;stroke:#A9C2FF;stroke-width:3.4455;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#84AEE5;stroke-width:1.1485;stroke-miterlimit:10;}\n\t.st5{fill:#8DBCF8;}\n\t.st6{fill:none;stroke:#7094D8;stroke-width:1.1485;stroke-miterlimit:10;}\n\t.st7{fill:#A5C5FF;}\n\t.st8{fill:#B7DEFF;}\n\t.st9{fill:#023F61;}\n\t.st10{fill:#BEBECF;}\n\t.st11{fill:#DEE0E8;}\n\t.st12{fill:#FB8E74;}\n\t.st13{fill:#FB8877;}\n\t.st14{fill:#713336;}\n\t.st15{fill:#FBA990;}\n\t.st16{fill:none;stroke:#022755;stroke-width:0.4884;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:1.1485;stroke-miterlimit:10;}\n\t.st18{fill:none;stroke:#73A5FF;stroke-width:3.4455;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st19{fill:#EDF4FF;}\n\t.st20{fill:#EBEDFC;}\n\t.st21{fill:#FFFFFF;}\n\t.st22{fill:#73A5FF;}\n\t.st23{fill:#024470;}\n\t.st24{fill:#005653;}\n\t.st25{fill:#FF8D68;}\n\t.st26{fill:#FF7759;}\n\t.st27{fill:#E86D5E;}\n\t.st28{fill:#008080;}\n\t.st29{fill:#F99747;}\n\t.st30{fill:#ED7D2B;}\n\t.st31{fill:none;stroke:#BB524F;stroke-width:1.1485;stroke-miterlimit:10;}\n\t.st32{fill:none;stroke:#E66657;stroke-width:1.026;stroke-miterlimit:10;}\n\t.st33{fill:none;stroke:#562525;stroke-width:1.1485;stroke-miterlimit:10;}\n\t.st34{fill:#2D2737;}\n\t.st35{fill:#51598D;}\n\t.st36{fill:#025B59;}\n\t.st37{fill:#0C0C0C;}\n\t.st38{fill:#3E3343;}\n\t.st39{fill:none;stroke:#2A2E59;stroke-width:1.026;stroke-miterlimit:10;}\n\t.st40{fill:none;stroke:#524B81;stroke-width:1.026;stroke-miterlimit:10;}\n\t.st41{fill:none;stroke:#3F3F3F;stroke-width:1.368;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.8,171.6c0,0,67.6-59.4,151.8-31.3s149.3,157.5,230.1,162.5s156.7-40.4,220.2-1.6s75.9,204.5-46.2,221.9 c-122.9,16.5-190.5-44.5-243.3-41.2c-52.8,3.3-180.6,66.8-282.1,37.9C158.7,491.6,68,295.3,228.8,171.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M720.4,181.5H392.9c-4.1,0-6.6-3.3-5.8-5.8L417.7,71c0.8-2.5,3.3-3.3,5.8-3.3h327.4c3.3,0,5.8,2.5,4.9,5.8 l-30.5,104.7C724.5,179.9,722,181.5,720.4,181.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M437.5,90h113.8 M428.4,137h113.8 M476.2,118.8h114.6 M434.2,105.6h34.6 M430,118.8h33.8 M569.4,90h40.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M589.2,158.4h-61l2.5-9.9h61l0.8,0.8l-2.5,9.1H589.2z M514.2,158.4h-61l2.5-9.9h61l0.8,0.8L514.2,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M695.6,145.2c-3.3-4.1-15.7-6.6-19-9.9c-1.6-2.5-1.6-5.8-1.6-8.2l3.3-2.5l3.3-4.9h1.6c1.6,0,8.2-7.4,5.8-9.1 c-0.8-0.8-1.6,0-3.3,0.8l3.3-5.8V104c2.5-9.1-3.3-16.5-13.2-16.5c-9.9,0-20.6,7.4-23.1,16.5v1.6l-0.8,5.8 c-0.8-0.8-1.6-1.6-3.3-0.8c-2.5,1.6,0,9.1,1.6,9.1h1.6v4.9l2.5,2.5c-1.6,3.3-3.3,6.6-5.8,8.2c-5.8,3.3-19.8,5.8-24.7,9.9 c-4.9,3.3-9.1,13.2-9.9,14.8h83.3C697.3,158.4,698.9,148.5,695.6,145.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M635.4,264.8H308c-3.3,0-5.8-3.3-4.9-5.8l30.5-104.7c0-2.5,2.5-3.3,4.9-3.3h327.4c3.3,0,5.8,2.5,4.9,5.8 l-30.5,104.7C639.5,263.2,637.9,264.8,635.4,264.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M628.8,256.6H301.4c-3.3,0-5.8-2.5-4.9-5.8l30.5-104.7c0.8-1.6,2.5-3.3,4.9-3.3h327.4c3.3,0,5.8,3.3,4.9,5.8 l-29.7,104.7C633.8,255.8,631.3,256.6,628.8,256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M404.5,256.6h164.1 M359.1,142.8h138.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M602.4,240.9H529c-3.3,0-5.8-2.5-4.9-4.9l19-66.8c0.8-2.5,4.1-4.9,7.4-4.9h73.4c4.1,0,5.8,2.5,4.9,4.9 L610.7,236C609.8,238.4,605.7,240.9,602.4,240.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M566.1,241.7l6.6-23.1l-10.7-4.1c0.8,0-19,6.6-20.6,8.2c-1.6,0.8-9.1,14.8-10.7,19H567H566.1z M603.2,241.7 v-19c-0.8-1.6-17.3-8.2-17.3-8.2l-12.4,4.1l-6.6,23.1H603.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M573.5,241.7l9.9-19.8l-21.4,0.8l-2.5,19H573.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M566.1,210.4l-4.1,2.5l-3.3,6.6l-0.8,9.1l6.6-2.5l4.9,5.8l6.6-4.9l4.9,3.3l5.8-12.4l-0.8-7.4l-2.5-0.8 L566.1,210.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M567.8,193.1c0,0-1.6-3.3-4.9-0.8c-3.3,1.6,0.8,9.9,3.3,7.4C567.8,197.2,567.8,193.1,567.8,193.1z  M590.9,193.1c0,0,3.3-4.1,5.8-1.6c1.6,1.6-5.8,10.7-6.6,8.2C588.4,197.2,590.9,193.1,590.9,193.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M583.4,217l3.3-15.7l-19,0.8l-4.1,14.8c0,0,3.3,7.4,6.6,10.7L583.4,217z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M599.1,186.5l-2.5,3.3c0,0.8-0.8,4.1-2.5,4.9l-1.6,1.6c0,0-16.5,4.1-24.7-1.6v-4.9c0.8-2.5-0.8-2.5,0.8-4.1 c1.6-0.8,2.5-2.5,2.5-4.1c0-0.8,0-2.5,1.6-4.1l4.9-2.5c0,0,1.6-3.3,4.9-4.1c3.3,0,9.9-1.6,14,2.5c4.1,4.1,2.5,8.2,3.3,9.9 C601.6,184.8,599.1,186.5,599.1,186.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M567.8,190.6c0,0-8.2,19,6.6,19.8c13.2,0.8,17.3-13.2,19.8-20.6c1.6-7.4,0.8-14.8-9.9-14.8 C573.5,175.8,568.6,185.7,567.8,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M571.9,183.2v3.3c-0.8,1.6-3.3,1.6-4.1,4.1l-1.6,6.6v-5.8c0-1.6,0.8-7.4,4.9-11.5c3.3-4.1,4.9-5.8,11.5-6.6 c6.6-0.8,10.7,1.6,12.4,4.9c1.6,3.3-0.8,11.5-0.8,11.5s0-4.1-0.8-4.9l-2.5-1.6h-10.7l-7.4-0.8L571.9,183.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M557.1,219.5l-6.6,15.7l5.8,2.5l-1.6,3.3 M587.6,219.5l-1.6,15.7l-7.4,2.5v3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M602.4,240.9H529c-3.3,0-5.8-2.5-4.9-4.9l19-66.8c0.8-2.5,4.1-4.9,7.4-4.9h73.4c4.1,0,5.8,2.5,4.9,4.9 L610.7,236C609.8,238.4,605.7,240.9,602.4,240.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M346.7,167.5h113.8 M337.7,214.5h113.8 M385.5,197.2h113.8 M343.4,183.2h34.6 M339.3,197.2h33.8 M478.7,167.5 h40.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M498.5,236.8h-60.2l-0.8-0.8l2.5-9.1h61.9l-2.5,9.1L498.5,236.8z M423.4,236.8h-61l-0.8-0.8l3.3-9.1h61 c0,0,0.8,0,0,0l-2.5,9.1V236.8z M490.2,131.2h63.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M678.3,406.7H350.9c-4.1,0-6.6-3.3-5.8-6.6l30.5-104.7c0.8-1.6,3.3-3.3,5.8-3.3h327.4c3.3,0,5.8,3.3,4.9,5.8 l-30.5,104.7C682.4,405,680.8,406.7,678.3,406.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M395.4,314.3h113.8 M386.3,361.3H501 M435,344h113.8 M392.9,330h33.8 M388,344h33.8 M527.4,314.3h40.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M547.2,383.6h-60.2l-0.8-0.8l3.3-9.1h61l-2.5,9.1L547.2,383.6z M472.1,383.6h-61v-0.8l2.5-9.1h61.9 L472.1,383.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M654.4,370.4c-3.3-4.1-16.5-6.6-19.8-10.7c-1.6-1.6-1.6-4.9-0.8-8.2l2.5-1.6l3.3-5.8l1.6,0.8 c1.6,0,8.2-7.4,6.6-9.9c-0.8-0.8-2.5,0-4.1,0.8l3.3-5.8v-1.6c2.5-8.2-3.3-15.7-13.2-15.7c-9.9,0-20.6,7.4-23.1,15.7v1.6l-0.8,5.8 c0-0.8-1.6-1.6-2.5-0.8c-3.3,1.6-0.8,9.9,0.8,9.9l1.6-0.8v5.8l2.5,2.5c-0.8,2.5-3.3,5.8-5.8,7.4c-5.8,4.1-19.8,6.6-24.7,10.7 c-4.9,3.3-9.1,12.4-9.9,14.8h83.3C655.2,382.8,656.9,373.7,654.4,370.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M640.4,560.1H312.9c-3.3,0-5.8-3.3-4.9-5.8l30.5-104.7c0.8-2.5,2.5-4.1,4.9-4.1h327.4c3.3,0,5.8,3.3,4.9,6.6 L645.3,556C644.5,558.5,642.8,560.1,640.4,560.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M357.5,468.6h114.6 M349.2,514.7H463 M397,497.4h113.8 M355,484.2h33.8 M350,497.4h34.6 M490.2,468.6h40.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M510,537h-61v-0.8l2.5-9.1h61.9L510,537z M434.2,537H374l-0.8-0.8l2.5-9.1h61.9L435,537H434.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M616.4,523.8c-3.3-4.1-15.7-6.6-19-9.9c-1.6-2.5-1.6-5.8-1.6-9.1l2.5-1.6l4.1-5.8l0.8,0.8 c1.6,0,8.2-7.4,6.6-9.1c-0.8-1.6-2.5-0.8-3.3,0.8l2.5-6.6l0.8-0.8c2.5-9.1-4.1-16.5-14-16.5c-9.9,0-19.8,7.4-22.3,16.5l-0.8,0.8 v6.6c-0.8-0.8-1.6-2.5-3.3-0.8c-2.5,1.6-0.8,9.1,0.8,9.1l1.6-0.8l0.8,5.8l1.6,2.5c-0.8,3.3-2.5,5.8-5.8,8.2 c-4.9,3.3-19,5.8-24.7,9.9c-4.1,3.3-8.2,13.2-9.1,14.8h82.5C618.1,536.2,618.9,527.1,616.4,523.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M526.5,546.1h52 M357.5,406.7h123.7 M501.8,406.7h29.7 M643.7,292.9h10.7c2.5,0,4.9,2.5,4.1,5.8l-4.9,14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.8,108.9h-4.9c-1.6,0-2.5-1.6-2.5-2.5l1.6-5.8c0-0.8,1.6-2.5,3.3-2.5h4.9c1.6,0.8,2.5,1.6,1.6,2.5 l-0.8,5.8C311.3,108.1,310.4,108.9,308.8,108.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M304.7,124.6h-4.9c-1.6,0-2.5-1.6-1.6-2.5l0.8-5.8c0.8-0.8,1.6-2.5,3.3-2.5h4.9c1.6,0,2.5,1.6,2.5,2.5 l-1.6,5.8C308,123.8,306.3,124.6,304.7,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M322,124.6h-5.8l-1.6-2.5l1.6-5.8c0-0.8,1.6-2.5,3.3-2.5h4.9c1.6,0,2.5,1.6,1.6,2.5l-0.8,5.8 C324.5,123.8,323.6,124.6,322,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M339.3,124.6h-5.8c-1.6,0-2.5-1.6-1.6-2.5l0.8-5.8l3.3-2.5h5.8l1.6,2.5l-1.6,5.8 C341.8,123.8,340.1,124.6,339.3,124.6z M301.4,140.3h-5.8c-1.6,0-2.5-0.8-1.6-2.5l0.8-4.9l3.3-2.5h5.8c0.8,0,1.6,0.8,1.6,2.5 l-1.6,4.9C303.8,139.5,302.2,140.3,301.4,140.3z M296.4,157.6h-4.9c-1.6,0-2.5-0.8-1.6-2.5l0.8-4.9c0.8-1.6,1.6-2.5,3.3-2.5h4.9 c1.6,0,2.5,0.8,2.5,2.5l-1.6,4.9C299.7,156.8,298.1,157.6,296.4,157.6z M317.9,140.3h-4.9c-1.6,0-2.5-0.8-2.5-2.5l1.6-4.9 c0-1.6,1.6-2.5,3.3-2.5h4.9c1.6,0,2.5,0.8,1.6,2.5l-0.8,4.9C320.3,139.5,319.5,140.3,317.9,140.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M310.4,170h-4.9c-1.6,0-2.5-0.8-2.5-1.6l1.6-5.8c0-1.6,1.6-2.5,3.3-2.5h4.9c1.6,0,2.5,0.8,1.6,2.5l-0.8,5.8 L310.4,170z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M394.6,77.6h-0.8H394.6h-1.6c-16.5,0-32.2,12.4-36.3,28.9v0.8h-0.8c-3.3,16.5,7.4,28.9,23.1,28 c15.7,0,30.5-12.4,34.6-27.2C418.5,92.5,409.4,79.3,394.6,77.6z M405.3,108.1c-3.3,9.9-14,19-24.7,19s-18.1-8.2-15.7-19.8v-0.8 c3.7-11.9,14.8-20,27.2-19.8C402.8,87.5,408.6,96.6,405.3,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M392.9,82.6c-0.8,2.5,0.8,4.1,2.5,4.1c8.2,2.5,13.2,10.7,9.9,20.6c-3.3,10.7-14,19.8-24.7,19.8 c-9.9,0-17.3-7.4-16.5-16.5c0-2.5-0.8-4.1-3.3-4.1s-4.9,2.5-4.9,5.8c-1.6,13.2,8.2,23.9,23.1,23.1c15.7,0,30.5-12.4,34.6-27.2 c4.9-14-1.6-26.4-14-29.7C397,77.6,393.7,80.1,392.9,82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M466.3,75.1h-1.6c-16.5,0-32.2,12.4-36.3,28.9s5.8,28.9,21.4,28.9h2.5c14.8-1.6,29.7-14,33.8-28.9 C490.2,88.3,481.2,76,466.3,75.1z M454,123.8l-1.6,0.8c-11.5,0-18.1-9.9-15.7-20.6c2.5-10.7,14.8-20.6,25.6-20.6h1.6 c10.7,0.8,16.5,9.9,14,20.6C474.6,114.7,464.7,123.8,454,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M476.2,107.3c-3.3,8.2-11.5,14.8-19.8,16.5c-2.5,0.8-4.1,2.5-4.9,4.1c-0.8,2.5,1.6,4.9,4.1,4.1 c12.4-2.5,23.9-11.5,28.9-23.1c0.8-2.5,0-4.9-3.3-4.9C479.5,104,477,105.6,476.2,107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M389.6,176.6h-54.4l2.5-9.9h54.4l0.8,0.8l-2.5,9.1H389.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7547 -0.6561 0.6561 0.7547 20.6074 463.1917)",
    className: "st22",
    cx: 629.7,
    cy: 204,
    rx: 27.1,
    ry: 21.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M665.1,230.2c-0.8,3.3-4.9,6.6-8.2,6.6s-5.8-3.3-4.9-6.6c0.8-3.3,4.1-6.6,8.2-6.6 C663.5,223.6,665.9,226.1,665.1,230.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M623,216.2l-1.6-0.8l-5.8-8.2c-0.8-0.8-0.8-3.3,0.8-4.1h4.1l4.9,6.6l16.5-14h4.1c0.8,1.6,0,3.3-0.8,4.9 l-19.8,14.8L623,216.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 805.7,
    cy: 613.7,
    rx: 102.3,
    ry: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M809.4,156.8c0,0-2.5,4.9-4.1,16.5c-1.6,11.5,2.5,77.5,2.5,77.5l45.4-4.9l-20.6-86.6L809.4,156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M783,435.6l-15.7,77.5l30.5,0.8c0,0,8.2-69.3,4.9-69.3C799.5,445.5,783,435.6,783,435.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M854,602.2c0,0-11.5,12.4-16.5,14.8c0.8,2.5,18.1,2.5,23.9-0.8c6.6-3.3,10.7-10.7,10.7-10.7v8.2h3.3l2.5-14 c0-2.5-2.5-5.8-2.5-5.8L854,602.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M849,448.8L860.6,589l13.2-0.8c0,0,15.7-103.1,9.9-138.6C877.1,414.1,849,448.8,849,448.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M860.6,589c0,0-4.1,10.7-9.9,16.5c-5.8,4.9,9.1,4.9,14.8,0l9.1-9.9c2.5-0.8-0.8-7.4-0.8-7.4L860.6,589z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M760,600.5c0,0-13.2,9.9-18.1,11.5c0,1.6,16.5,4.9,23.1,2.5c6.6-2.5,13.2-8.2,13.2-8.2l-2.5,7.4l3.3,0.8 l5.8-13.2c0.8-3.3-2.5-6.6-2.5-6.6L760,600.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M781.4,447.9L769,588.1l13.2,0.8c0,0,33-99,33-134.4C814.4,418.2,781.4,447.9,781.4,447.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M769,588.1c0,0-5.8,9.9-12.4,14c-6.6,4.1,7.4,6.6,14.8,2.5c7.4-4.1,7.4-6.6,9.9-7.4c2.5-0.8,0.8-8.2,0.8-8.2 L769,588.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M733.6,224.4l-27.2-5.8c0,0,0,4.1,2.5,4.9l2.5,0.8c0,0,5.8,14,8.2,15.7l20.6,9.1l4.1-17.3L733.6,224.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M752.5,245.9l-4.1-9.1l-4.9-11.5c0.8,0-12.4-4.9-14-7.4l-3.3-2.5c0,0-2.5,4.1,0.8,7.4l7.4,5.8 c0,0-0.8,9.1,0.8,14c0.8,4.1,4.9,6.6,4.9,6.6L752.5,245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M794.6,260.7c0,0-18.1,29.7-19,27.2c0-3.3-23.1-42.9-23.1-42.9l-12.4,4.1c0,0,18.1,58.6,30.5,68.5l4.9,0.8 c4.1,0,31.3-29.7,31.3-29.7L794.6,260.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M811.9,226.1c0,0-9.9,4.1-14.8,10.7s-18.1,37.9-18.1,37.9s7.4,12.4,23.9,17.3l23.1-42.1L811.9,226.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M799.5,326.7l0.8,16.5c0,0-19,90.7-19.8,112.2c-0.8,20.6,14.8,63.5,14.8,63.5s66.8-0.8,89.1-5.8l2.5-45.4 c0,0,3.3-79.2,0-101.4c-3.3-22.3-16.5-34.6-16.5-34.6l-4.1-10.7L799.5,326.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M857.3,221.1c0,0,17.3,8.2,22.3,16.5c5.8,9.1,22.3,55.3,22.3,55.3s-18.1,6.6-34.6,6.6l3.3,19.8 c1.6,4.1-4.1,6.6-4.1,6.6s-37.9,9.9-66.8,4.1c0,0-3.3-0.8-3.3-2.5l0.8-5.8l-4.1-31.3c-0.8-4.1-9.1-17.3-8.2-22.3 c0.8-4.9,14-28.9,14-28.9s9.1-9.9,12.4-13.2c4.1-2.5,14-2.5,14-2.5L857.3,221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M823.5,207.1c0,0.8,2.5,14-4.9,23.1c-7.4,9.9,21.4,9.1,28-0.8c6.6-8.2,5.8-9.9,5.8-9.9s-4.9-15.7-3.3-26.4 C848.2,184,823.5,189.8,823.5,207.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M823.5,151.8c0,0-8.2,1.6-13.2,14.8c-4.9,13.2-1.6,40.4,1.6,43.7s12.4,1.6,26.4-2.5c14-4.9,19-19.8,21.4-28.9 C864.7,160.1,848.2,141.1,823.5,151.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M807,166.7c0,0,8.2,18.1,37.1,19.8l7.4,33l17.3,8.2c0,0,5.8-60.2-7.4-74.2s-37.9-11.5-47-2.5 C805.3,159.3,807,166.7,807,166.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M857.3,221.1l-6.6-6.6c0,0-6.6,17.3-27.2,18.1c0,0-2.5-4.1-0.8-10.7l-3.3,3.3c0,0-7.4,9.9-6.6,13.2 c0.8,3.3,10.7-2.5,10.7-2.5s11.5,7.4,15.7,7.4C844.1,244.2,856.5,221.9,857.3,221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M844.9,185.7c0,0,3.3-4.9,6.6-3.3c3.3,1.6-2.5,13.2-6.6,14C840.8,196.4,843.3,189,844.9,185.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M852.3,254.9l12.4,42.9 M844.9,257.4c0,0,2.5,8.2,11.5,13.2 M858.9,247.5c0,0,0.8-11.5,14-12.4 M797.1,242.6 c0,0-12.4,20.6-12.4,25.6c0,4.9,8.2,19,8.2,19l9.9,26.4 M841.6,329.2l13.2-14.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M726.1,228.5l-16.5-4.1l2.5,4.1l12.4,4.9 M712.1,228.5l2.5,5.8l10.7,3.3 M728.6,225.2l4.9,3.3l3.3-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M804.5,340.7c0,0,21.4,6.6,41.2-1.6 M811.1,348.1c0,0,10.7,4.1,28-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M764.9,367.1l41.2-23.9l31.3,54.4l-41.2,23.9L764.9,367.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M844.9,363.8l-8.2,9.1c-2.5,1.6-15.7,2.5-15.7,2.5s-5.8,9.9-7.4,9.9c-1.6-0.8-0.8-1.6-0.8-1.6 s-0.8-17.3,0.8-19.8c0.8-1.6,19.8-7.4,19.8-7.4l2.5-2.5L844.9,363.8 M896,294.5l6.6,19.8c2.5,6.6-44.5,39.6-52,45.4l-5.8,4.1 l-8.2-9.9l40.4-41.2l-5.8-13.2L896,294.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M813.6,385.2l2.5-11.5 M812.7,375.4l2.5-6.6 M813.6,363.8l-0.8,21.4h3.3l4.9-9.9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 230.3,
    cy: 613.7,
    rx: 102.3,
    ry: 8.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M189.2,586.5c0,0,2.5-4.9,9.9-4.1c8.2,1.6,9.1,3.3,9.9,7.4c0.8,4.1,4.1,8.2,5.8,9.1c1.6,0.8,9.1,5.8,14,6.6 c5.8,0.8,6.6,4.1,4.9,5.8c-0.8,1.6-22.3,2.5-26.4,2.5l-19.8-1.6C184.3,610.4,189.2,587.3,189.2,586.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M183.4,476.8c0,0-2.5-12.4,11.5-16.5c13.2-4.9,15.7,1.6,19.8,13.2s-3.3,112.2-3.3,112.2s-15.7,2.5-19.8,0 c0,0-11.5-65.2-10.7-82.5C181.8,485,183.4,476.8,183.4,476.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M190,581.5l23.1-2.5v8.2c0,0-14,2.5-23.1,1.6V581.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M180.1,226.9c0,0-11.5,0-18.1,25.6c-6.6,25.6-10.7,56.9-8.2,64.3c2.5,7.4,28.9,29.7,38.8,29.7 s10.7-7.4,8.2-13.2c-2.5-5.8-20.6-23.1-20.6-23.1s15.7-49.5,14.8-62.7C194.1,234.3,186.7,226.9,180.1,226.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M322,218.6l-1.6,0.8l4.1-8.2c0,0,10.7-0.8,12.4,3.3l-4.9,10.7L322,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M327.8,195.5c0,0,0-8.2,2.5-9.9c3.3-0.8,6.6,1.6,6.6,1.6s4.9-0.8,6.6,1.6c1.6,1.6,1.6,4.9,1.6,4.9 s2.5,0.8,3.3,3.3s-0.8,7.4-0.8,7.4s-3.3,4.1-6.6,3.3C337.7,206.3,327.8,195.5,327.8,195.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M322.8,202.1c0,0-1.6-10.7,0-12.4l13.2-18.1c0,0,2.5,3.3,0.8,5.8l-6.6,13.2v9.1 C330.2,199.7,326.1,202.1,322.8,202.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M323.6,211.2c0,0-3.3-17.3-0.8-19.8c1.6-2.5,11.5-1.6,13.2-0.8l7.4,9.9c0.8,2.5-4.1,12.4-6.6,14 C333.5,217,325.3,214.5,323.6,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M317,222.8l3.3-6.6c0,0,9.1-1.6,13.2,4.9l0.8,2.5l-3.3,5.8L317,222.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M228.8,148.5c0,0,9.1,1.6,14,15.7c4.9,14.8,1.6,44.5-1.6,47.8s-14,2.5-28.9-2.5 c-14.8-4.9-20.6-21.4-23.1-32.2C183.4,157.6,201.6,137,228.8,148.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M195.8,226.1l7.4-27.2c0,0,14.8-4.1,23.9,5.8l3.3,4.1v18.1C230.4,226.9,214.8,229.4,195.8,226.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M177.7,369.6c0,0-4.9,32.2,0,69.3c4.9,37.1,17.3,41.2,27.2,41.2c9.9,0,13.2-29.7,14.8-42.9 c1.6-13.2,9.1-57.7-4.1-67.6C201.6,358.9,185.1,358,177.7,369.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M213.9,413.3c0,0-11.5-29.7,8.2-42.9c19.8-13.2,34.6-11.5,38.8,9.9c4.9,21.4,5.8,94.9-0.8,109.7 C253.5,504.8,230.4,481.7,213.9,413.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M246.1,149.4c0,0,4.1,5.8,1.6,12.4c-2.5,6.6-12.4,9.1-12.4,9.1s3.3,4.1,0,10.7l-1.6,3.3c0,0,2.5,7.4,1.6,9.1 c-0.8,1.6-3.3,1.6-3.3,1.6s-4.1-9.9-4.9-9.1c-1.6,0.8-4.9,4.9-4.9,9.1c0,4.1,0.8,7.4,0,9.9c-0.8,2.5-14,2.5-19.8,1.6 c-5.8-0.8-14.8-19-17.3-26.4c0,0-2.5-11.5,1.6-20.6c0,0-0.8-7.4,6.6-15.7c7.4-8.2,31.3-4.9,35.5-2.5c0,0-0.8-4.1,4.1-3.3 C237,139.5,243.6,143.6,246.1,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M232.9,189.8c0,0-0.8-5.8-5.8-3.3c-4.9,2.5,0.8,16.5,4.9,15.7C235.4,201.3,233.7,191.4,232.9,189.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M191.7,226.1c0,0,1.6-7.4,4.1-8.2s24.7-3.3,37.1,4.1c4.9,4.9,4.9,7.4,4.9,7.4S200.7,222.8,191.7,226.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M186.7,224.4c0,0,38.8-2.5,66,9.1c12.4,5.8,40.4,33.8,40.4,33.8l22.3-46.2c0,0,13.2-4.9,18.1,7.4 c0,0-14.8,54.4-26.4,71.8c-7.4,6.6-42.9-14-42.9-14s5.8,72.6,4.1,104.7c-2.5,5.8-51.1,9.1-60.2,8.2c-8.2-0.8-38.8-10.7-39.6-12.4 c-0.8-1.6,4.9-75.9,3.3-85c-1.6-9.1-4.9-51.1-3.3-57.7C169.4,238.4,175.2,226.9,186.7,224.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M228,588.1c0,0,1.6-4.9,9.9-3.3c8.2,0.8,9.1,2.5,9.9,6.6c0.8,4.1,4.1,8.2,5.8,9.1c1.6,0.8,8.2,5.8,14,6.6 c5.8,0.8,6.6,4.1,4.9,5.8c-0.8,1.6-22.3,3.3-26.4,2.5l-19.8-1.6C222.2,612.1,227.1,589.8,228,588.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M231.3,479.3c0,0-0.8-13.2,13.2-15.7c14-3.3,15.7,3.3,19,15.7c2.5,12.4-16.5,110.5-16.5,110.5 s-15.7,0.8-19-1.6c0,0-4.9-66-2.5-84.1L231.3,479.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M226.3,589.8c0,0,12.4,3.3,22.3,1.6l0.8-7.4l-23.1-1.6V589.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M209.8,405.9c0,0,13.2,42.1,23.1,62.7 M236.2,476.8c0,0,8.2-4.9,16.5,0 M235.4,481.7c0,0,6.6-3.3,17.3,4.1  M190,471c0,0,4.9-4.1,16.5,0.8 M193.3,476c0,0,7.4-4.1,14.8,1.6 M210.6,483.4l-2.5,94.9 M246.1,404.2c0,0,9.9,5.8,14.8-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M256,405c0,0,4.9,38.8,4.1,63.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M171.9,260.7l4.9,53.6 M253.5,278.9c0,0,36.3,26.4,53.6,21.4 M297.2,273.1c0,0,7.4,4.1,6.6,13.2 M294.8,269 c0,0,8.2-2.5,13.2,5.8 M251.9,236.8c0,0-19.8,9.9-6.6,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M223.8,206.3c0,0,3.3,8.2,14.8,6.6 M329.4,189l3.3-3.3c0,0,2.5,0,4.1,1.6 M333.5,189l5.8-2.5 c0,0,4.1,0.8,4.9,3.3v4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M214.8,160.1c-9.1-4.9-20.6,0.8-20.6,0.8s1.6-5.8,8.2-8.2 M195,164.2c0,0,2.5,0,4.9,4.9 M231.3,143.6 c0,0,11.5,1.6,11.5,13.2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePage01);
export default __webpack_public_path__ + "static/media/home_page-01.9a2cb29f44dc5e856e83db4fe8aee3e0.svg";
export { ForwardRef as ReactComponent };